import React from 'react';
import clsx from 'clsx';
import styles from './RouteBar.module.scss';

import RouteForm from './RouteForm';
import Info from './Info';
import RouteStep from './RouteStep';
import { TRAVEL_MODES } from '../utils/Constants';
import { useDeviceDetection } from '../utils/DeviceDetection';
import Button, { ButtonStyles } from './Button';
import Label from './Label';
import Icon from './Icon';
import { hasBrandLabel } from '../api/brandUtil';

export default function RouteBar({
	show,
	result,
	calcRouteResponse,
	searchParameters,
	onCalcRouteParamsChange,
	calcRouteCustomParams,
	showMobileSteps,
	setShowMobileSteps,
	travelMode,
	setTravelMode
}) {
	const isMobile = useDeviceDetection();

	const calcRouteByTravelMode =
		calcRouteResponse && calcRouteResponse[travelMode]
			? calcRouteResponse[travelMode]
			: null;

	const errorMsg = (
		<p className={styles.error}>
			Spiacenti, non siamo riusciti a calcolare le indicazioni stradali{' '}
			{travelMode === TRAVEL_MODES.DRIVING
				? 'in automobile'
				: travelMode === TRAVEL_MODES.TRANSIT
				? 'per il trasporto pubblico'
				: travelMode === TRAVEL_MODES.WALKING
				? 'a piedi'
				: ''}{' '}
			da <strong>{searchParameters?.formattedAddress}</strong> a{' '}
			<strong>{result?.formattedAddress}</strong>
		</p>
	);

	const mapControlsStyle = {
		padding: '9px 20px',
		fontWeight: 600
	};

	const isBrandLabel = hasBrandLabel(result);

	return show ? (
		<div className={styles.root}>
			{!isMobile ? (
				<>
					<div className={styles.routeHeader}>Calcola percorso</div>
					<RouteForm
						travelMode={travelMode}
						setTravelMode={setTravelMode}
						result={result}
						calcRouteResponse={calcRouteResponse}
						searchParameters={searchParameters}
						onSubmit={onCalcRouteParamsChange}
					/>
				</>
			) : null}

			<div
				className={clsx(
					styles.infoContainer,
					isBrandLabel ? styles.infoContainerColumn : null
				)}
			>
				{calcRouteByTravelMode ? (
					<>
						{calcRouteCustomParams ? null : (
							<div>{result.brand}</div>
						)}
						<div className={styles.flexChild}>
							<Info
								name={
									calcRouteCustomParams ? null : result.name
								}
								routeDistance={calcRouteByTravelMode?.distance}
								routeTime={calcRouteByTravelMode?.duration}
								variant={isBrandLabel ? 'block' : null}
							/>
							{isMobile && !showMobileSteps ? (
								<Label
									className={styles.label}
									icon={
										<Icon
											className={styles.icon}
											icon="icon/compass_blue.png"
											size="small"
										/>
									}
									text="Indicazioni stradali"
									onClick={() => setShowMobileSteps(true)}
								/>
							) : null}
						</div>
					</>
				) : (
					errorMsg
				)}
			</div>
			{!isMobile || (isMobile && showMobileSteps) ? (
				<>
					<span className={styles.rootStepsTitle}>Dettagli:</span>
					<div className={styles.routeStepsContainer}>
						{calcRouteResponse &&
							calcRouteResponse[travelMode] &&
							calcRouteResponse[
								travelMode
							].steps.map((step, index) => (
								<RouteStep
									step={step}
									isFirst={index === 0}
									key={index}
								/>
							))}
					</div>
				</>
			) : null}
			{isMobile && showMobileSteps ? (
				<div className={styles.mobileControls}>
					<Button
						icon={
							<Icon
								className={styles.icon}
								icon="pin/pin_agenzie.png"
								size="small"
								textOn="right"
							/>
						}
						text="mappa"
						onClick={() => setShowMobileSteps(false)}
						variant={ButtonStyles.SECONDARY}
						style={mapControlsStyle}
					/>
				</div>
			) : null}
		</div>
	) : null;
}
